import { render, staticRenderFns } from "./FlixcheckPolicyChecksOverview.vue?vue&type=template&id=9182815a&scoped=true"
import script from "./FlixcheckPolicyChecksOverview.vue?vue&type=script&lang=ts"
export * from "./FlixcheckPolicyChecksOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9182815a",
  null
  
)

export default component.exports